import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Reveal, PageHero } from "../components/Bits";
import { EPISODES } from "../data/show";
import { EPISODE_BEATS } from "../data/episodeBeats";

export default function EpisodeDetail() {
  const { n } = useParams();
  if (n === "101") return <Navigate to="/episodes#pilot" replace />;
  const idx = EPISODES.findIndex((e) => e.n === n);
  const ep = EPISODES[idx];
  const beats = EPISODE_BEATS[n];
  if (!ep || !beats) return <Navigate to="/episodes" replace />;
  const prev = EPISODES[idx - 1];
  const next = EPISODES[idx + 1];
  const prevTo = prev.n === "101" ? "/episodes#pilot" : `/episodes/${prev.n}`;

  return (
    <div data-testid={`episode-detail-${n}`}>
      <PageHero testid="episode-detail-hero" eyebrow={`Episode ${ep.n} · Escalation ${ep.level}/10`} title={ep.title} sub={ep.crisis} />
      <section className="section">
        <div className="wrap max-w-4xl">
          <Link to={`/episodes#ep-${n}`} className="text-link" data-testid="episode-back-link"><ArrowLeft size={14} /> Back to Season One</Link>
          <div className="mt-10">
            {beats.map((b, i) => (
              <Reveal key={b.title}>
                <article id={`ep${n}-beat-${i + 1}`} className="beat" data-testid={`ep-${n}-beat-${i + 1}`}>
                  <span className="beat-n">{String(i + 1).padStart(2, "0")}</span>
                  <div>
                    <p className={`slate ${b.act.includes("Break") ? "text-[var(--coral)]" : ""}`}>{b.act}</p>
                    <h3 className="display text-2xl md:text-3xl mt-2">{b.title}</h3>
                    <p className="mt-3 leading-relaxed text-[var(--muted)]">{b.text}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
          <div className="flex justify-between gap-4 mt-14 border-t pt-8">
            <Link to={prevTo} className="text-link" data-testid="episode-prev-link"><ArrowLeft size={14} /> EP {prev.n}</Link>
            {next && <Link to={`/episodes/${next.n}`} className="text-link" data-testid="episode-next-link">EP {next.n} · {next.title} <ArrowRight size={14} /></Link>}
          </div>
        </div>
      </section>
    </div>
  );
}
